.container {
  position: relative;
  padding: 0.8rem 0.8rem;
  display: flex;
  justify-content: space-between;
  min-height: 7.2rem;
  gap: 1.6rem;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-grey-7);
    margin-bottom: 1.2rem;
  }
}

.version-text {
  color: var(--color-grey-3);
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.9rem;
  text-align: center;

  &[data-is-selected='true'] {
    color: var(--color-secondary);
  }
}

.asset-thumbnail {
  width: 7.6rem;
  min-width: 7.6rem;
  flex-basis: 0;
  height: 4.275rem;
  border-radius: 0.6rem;
  border: none;
  object-fit: cover;
  overflow: hidden;
}

.version-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 0.4rem;
  min-width: 0;
}

.version-title {
  font-style: normal;
  line-height: 1.8rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #ffffff;

  &[data-is-selected='true'] {
    color: var(--color-secondary);
  }
}

.version-uploader-and-time {
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: var(--color-grey-4);
}

.delete-button {
  cursor: pointer;
  margin-right: 0.8rem;

  svg path {
    fill: #959bab;
    transition: all 0.1s ease-out;
  }

  :hover {
    svg path {
      fill: white;
    }
  }
}
